import React from "react";

export default function ApiErrorState({
  message = "Unable to load data right now.",
  onRetry,
  retryLabel = "Try again",
  className = "",
  compact = false,
}) {
  return (
    <div
      className={[
        "new-api-error-state",
        compact ? "is-compact" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <p>{message}</p>

      {typeof onRetry === "function" ? (
        <button type="button" onClick={onRetry}>
          {retryLabel}
        </button>
      ) : null}
    </div>
  );
}
